import { Component, Input } from '@angular/core';
import { ModeService } from 'src/services/mode.service';
import { Order } from '../../../../interfaces/order.interface';
import { HandoffType } from '../../../../interfaces/handoff-type.enum';
import { Select } from '@ngxs/store';
import { GlobalStateModel } from 'src/store/state.model';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-nav-order-type',
  template: `
    <ng-container [ngSwitch]="modeService.mode">
      <app-mobile-nav-order-type *ngSwitchCase="'mobile'" [order]="order" [layout]="layout"></app-mobile-nav-order-type>
      <app-desktop-nav-order-type *ngSwitchCase="'desktop'" [order]="order"></app-desktop-nav-order-type>
      <app-mobile-nav-order-type *ngSwitchCase="'tableside'" [order]="order" [layout]="layout"></app-mobile-nav-order-type>
    </ng-container>
  `,
})
export class NavOrderTypeComponent {
  @Select((state: GlobalStateModel) => state.order.brandHandoffs) brandHandoffs$: Observable<{ handoff: HandoffType; label: string }[]>;

  @Input() order: Order;
  @Input() layout: string;
  handoffs = HandoffType;
  constructor(public modeService: ModeService) {}
}
